import { render, staticRenderFns } from "./ModelV1.vue?vue&type=template&id=4558b394&scoped=true"
import script from "./ModelV1.vue?vue&type=script&lang=js"
export * from "./ModelV1.vue?vue&type=script&lang=js"
import style0 from "./ModelV1.vue?vue&type=style&index=0&id=4558b394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558b394",
  null
  
)

export default component.exports